import { z } from 'zod'

import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

export const PatientFoodStock = z.object({
  personaInfoSummary: PersonaInfoSummary,
  stockFoods: z
    .object({
      minimumQuantity: z.number(),
      amountItem: z.number()
    })
    .nullable(),
  amount: z.number()
})
export type PatientFoodStock = z.infer<typeof PatientFoodStock>

export const PatientFoodStockList = PatientFoodStock.array()
export type PatientFoodStockList = z.infer<typeof PatientFoodStockList>
